import { render, staticRenderFns } from "./MaterialCategoryDialog.vue?vue&type=template&id=0529407e&"
import script from "./MaterialCategoryDialog.vue?vue&type=script&lang=js&"
export * from "./MaterialCategoryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports